module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YktQi0/tc-custom/9781847675705.jpg?1734582422485",
      "alt": "This image is the cover for the book Wilderness Journeys, Canongate Classics"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wilderness Journeys, Canongate Classics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Five works by the naturalist considered the father of the modern conservation movement, documenting the unspoiled beauty of nineteenth-century America.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("When we try to pick out anything by itself, we find it hitched to everything else in the universe. —")]), _vm._v("John Muir,"), _c('i', [_vm._v(" My First Summer in the Sierra")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The name of John Muir has come to stand for the protection of wild land and wilderness in both America and Britain. Born in Scotland in 1838, Muir is famed as the father of American conservation and the founder of the Sierra Club. This collection, including the rarely seen "), _c('i', [_vm._v("Stickeen")]), _vm._v(", presents the finest of Muir’s writings, painting a portrait of a man whose generosity, passion, and vision are an inspiration to this day."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Combining acute observation, amusing anecdotes, and a sense of inner discovery, Muir’s writings of his travels though some of the greatest landscapes on Earth, including the Carolinas, Florida, Alaska, and those lands that were to become the great National Parks of Yosemite and the Sierra Valley, raise an awareness of nature to a spiritual dimension."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Includes an introduction by Graham White\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Muir, Graham White\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canongate\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0